import React from 'react';
import { Button } from '../ui/button';

/**
 * Right-hand auth controls shown on the desktop nav.
 * Dark-luxury styling — buttons sit on the dark navbar.
 */
const UserMenu = ({ user, isPro, onLogout, onGoToAuth }) => {
  if (!user) {
    return (
      <Button
        className="bg-gradient-to-r from-cyan-500 to-violet-500 hover:from-cyan-400 hover:to-violet-400 text-white shadow-[0_0_18px_rgba(139,92,246,0.4)]"
        size="sm"
        onClick={onGoToAuth}
        data-testid="nav-signin-btn"
      >
        Sign in
      </Button>
    );
  }
  return (
    <>
      <div className="hidden md:flex flex-col items-end mr-2">
        <span className="text-xs text-white/60 truncate max-w-[140px]">{user.email}</span>
        <span className="text-[10px] uppercase tracking-wide text-cyan-300 font-semibold">
          {isPro ? 'Pro' : 'Free'} Plan
        </span>
      </div>
      <Button
        className="bg-white/10 hover:bg-white/20 text-white border border-white/10"
        size="sm"
        onClick={onLogout}
        data-testid="nav-logout-btn"
      >
        Logout
      </Button>
    </>
  );
};

export default UserMenu;
